"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var offSetApi = _interopRequireWildcard(require("@/api/offSetApi.js"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _componentsApi = require("@/api/componentsApi");
var _constants = require("@/utils/constants");
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
var _index = _interopRequireDefault(require("@/components/StoreAddressPicker/index.vue"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    StoreAddressPicker: _index.default
  },
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 地区选项数据
      areaOptions: [],
      // 位置数据
      locationData: {
        region: [],
        storeAddress: '',
        longitude: '',
        latitude: '',
        regionName: ''
      },
      // 接口不可编辑
      urlImage: '',
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      constants: this.$constants,
      companyappAutoList: [],
      companyappAutoListA: [],
      companyappAutoListB: [],
      dataRenage: [],
      //参数
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        writeOffType: null,
        // 核销方式筛选
        editType: null // 数据来源筛选
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      dialogVisible: false,
      form: {},
      formStoreSelect: [],
      //拿到商家列表
      formStoreSelectedOne: [],
      //拿到员工列表
      storeType: false,
      offsetStateOption: [{
        label: '已开业',
        value: 1
      }, {
        label: '筹备中',
        value: 2
      }, {
        label: '停用',
        value: -1
      }],
      verificationOption: [{
        label: '小程序',
        value: 1
      }, {
        label: '扫码枪',
        value: 2
      }],
      editTypeOption: [{
        label: '平台',
        value: 1
      }, {
        label: '接口',
        value: 2
      }],
      titleType: false,
      dialogAddVisible: false,
      dowCoExcleText: '',
      showPopup: false,
      rules: {
        storeName: [{
          required: true,
          message: '请输入门店名称',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择店铺状态',
          trigger: 'blur'
        }],
        writeOffType: [{
          required: true,
          message: '请选择核销方式',
          trigger: 'blur'
        }],
        editType: [{
          required: true,
          message: '请选择数据来源',
          trigger: 'change'
        }]
        // externalId: [
        // 	{
        // 		validator: function(rule, value, callback) {
        // 			const writeOffType = this.form.writeOffType;
        // 			if (writeOffType === 2 && (!value || value.trim() === '')) {
        // 				callback(new Error('请选择扫码枪时，扫码枪唯一标识为必填项'));
        // 			} else {
        // 				callback();
        // 			}
        // 		}.bind(this),
        // 		trigger: ['blur', 'change']
        // 	}
        // ],
      }
    };
  },
  computed: {
    // 计算是否禁用：编辑模式且数据来源为接口时禁用
    isDisabled: function isDisabled() {
      return !this.titleType && this.form.editType === 2;
    }
  },
  watch: {
    'form.writeOffType': function formWriteOffType(newVal, oldVal) {
      var _this = this;
      // 当核销方式改变时，触发扫码枪唯一标识的验证
      this.$nextTick(function () {
        if (_this.$refs.form && newVal !== oldVal) {
          _this.$refs.form.validateField('externalId');
        }
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.handleApiOffsetList(this.listPram);
    this.handleSelectedList();
    if (JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId === null) {
      this.handleStoreListSelect();
    } else {
      this.form.offlineSupplierId = JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId;
      this.handleSelectedList();
    }
    this.getAreaData();
  },
  methods: {
    // 获取地区数据
    getAreaData: function getAreaData() {
      var _this2 = this;
      dangaoActApi.getShopSelfAddress().then(function (res) {
        _this2.areaOptions = res || [];
      }).catch(function (err) {
        console.error('获取地区数据失败：', err);
        _this2.$message.error('获取地区数据失败');
      });
    },
    // 添加店铺
    handleAddStore: function handleAddStore() {
      // 确保form对象被正确初始化
      this.form = {
        offlineSupplierId: JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId,
        writeOffType: 1,
        // 默认核销方式为小程序
        editType: 1,
        // 默认数据来源为平台
        status: null,
        storeName: '',
        systemAdmins: [],
        systemEmployees: [],
        remark: '',
        externalId: ''
      };
      // 重置位置数据
      this.locationData = {
        region: [],
        storeAddress: '',
        longitude: '',
        latitude: '',
        regionName: ''
      };
      this.dialogVisible = true;
      this.titleType = true;
    },
    // 编辑店铺
    openOrderDetailEdit: function openOrderDetailEdit(row) {
      console.log(row);
      this.urlImage = row.avatar;
      this.form = row;
      this.dialogVisible = true;
      // 处理位置数据
      this.locationData = {
        region: row.storeCity ? row.storeCity.split(',').map(function (item) {
          return Number(item);
        }) : [],
        storeAddress: row.storeAddress || '',
        longitude: row.longitude ? String(row.longitude) : '',
        latitude: row.latitude ? String(row.latitude) : '',
        regionName: row.regionName || ''
      };
      this.titleType = false;
      this.handleSelectedList();
    },
    // 弹窗打开动画结束后的回调
    handleDialogOpened: function handleDialogOpened() {
      var _this3 = this;
      this.$nextTick(function () {
        if (_this3.$refs.addressPicker) {
          _this3.$refs.addressPicker.refreshMap();
        }
      });
    },
    // 获取地区名称
    getRegionName: function getRegionName() {
      var _this4 = this;
      if (!this.locationData.region || this.locationData.region.length < 3) return '';
      var province = this.areaOptions.find(function (item) {
        return item.id === _this4.locationData.region[0];
      });
      if (!province) return '';
      var city = (province.child || []).find(function (item) {
        return item.id === _this4.locationData.region[1];
      });
      if (!city) return '';
      var district = (city.child || []).find(function (item) {
        return item.id === _this4.locationData.region[2];
      });
      if (!district) return '';
      return province.name + '/' + city.name + '/' + district.name;
    },
    //添加店铺
    handleSubmitEdit: function () {
      var _handleSubmitEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var isValid, parmres;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.validateForm();
            case 1:
              isValid = _context.v;
              if (isValid) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (this.form.storeName) {
                _context.n = 3;
                break;
              }
              return _context.a(2, this.$message.error('请输入店铺名称'));
            case 3:
              parmres = {
                avatar: this.form.avatar,
                offlineSupplierId: this.form.offlineSupplierId,
                remark: this.form.remark,
                status: this.form.status,
                writeOffType: this.form.writeOffType,
                editType: this.form.editType,
                externalId: this.form.externalId,
                storeAddress: this.locationData.storeAddress,
                storeCity: this.locationData.region ? this.locationData.region.join(',') : null,
                regionName: this.getRegionName(),
                latitude: this.locationData.latitude || null,
                longitude: this.locationData.longitude || null,
                storeName: this.form.storeName,
                systemAdmins: this.form.systemAdmins,
                systemEmployees: this.form.systemEmployees,
                id: this.form.id
              };
              _context.n = 4;
              return offSetApi.offlineUserStoreSave(parmres);
            case 4:
              this.$message.success(this.titleType ? '添加成功' : ' 修改成功');
              this.dialogVisible = false;
              this.listPram.page = 1;
              this.handleApiOffsetList(this.listPram);
              this.form = {}; //调用数据后 将接口清空
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleSubmitEdit() {
        return _handleSubmitEdit.apply(this, arguments);
      }
      return handleSubmitEdit;
    }(),
    // 表单验证方法
    validateForm: function validateForm() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.$refs.form.validate(function (valid, invalidFields) {
          if (!valid) {
            console.log('表单验证失败:', invalidFields);
            // 如果验证失败，显示第一个错误信息
            var firstError = Object.values(invalidFields)[0][0].message;
            _this5.$message.error(firstError);
          }
          resolve(valid);
        });
      });
    },
    //上传图片
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.uploadItem.call(this, file);
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleUploadForm(_x) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    uploadItem: function uploadItem(param) {
      var _this6 = this;
      var formData = new FormData();
      var data = {
        model: 'supplier',
        pid: 10
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
        _this6.form.avatar = res.url;
        _this6.urlImage = res.url;
        loading.close();
        _this6.$message.success('上传成功');
      }).catch(function (res) {
        loading.close();
      });
    },
    closedialog: function closedialog() {
      this.dialogVisible = false;
      this.urlImage = '';
      this.form = {};
      this.locationData = {
        region: [],
        storeAddress: '',
        longitude: '',
        latitude: '',
        regionName: ''
      };
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.form, dataIndex, '');
    },
    // 获取核销方式名称
    getVerificationMethodName: function getVerificationMethodName(value) {
      var option = this.verificationOption.find(function (item) {
        return item.value === value;
      });
      return option ? option.label : '';
    },
    // 获取数据来源名称
    getEditTypeName: function getEditTypeName(value) {
      var option = this.editTypeOption.find(function (item) {
        return item.value === value;
      });
      return option ? option.label : '';
    },
    // 核销订单列表
    handleApiOffsetList: function () {
      var _handleApiOffsetList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(listPram) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return offSetApi.offlineStoreList(listPram);
            case 1:
              res = _context3.v;
              this.listData.list = res.list;
              this.listData.total = res.total;
              this.listLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleApiOffsetList(_x2) {
        return _handleApiOffsetList.apply(this, arguments);
      }
      return handleApiOffsetList;
    }(),
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handleApiOffsetList(this.listPram);
    },
    //获取到店铺列表
    handleSelectedList: function () {
      var _handleSelectedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return offSetApi.offlineUserStoreList({
                offlineSupplierId: this.form.offlineSupplierId
              });
            case 1:
              res = _context4.v;
              this.formStoreSelectedOne = res;
              this.handerSearch();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleSelectedList() {
        return _handleSelectedList.apply(this, arguments);
      }
      return handleSelectedList;
    }(),
    // 获取到商家列表 当缓存里没有时调
    handleStoreListSelect: function () {
      var _handleStoreListSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return customerOrderApi.companyAutoListByTypetApi({
                type: 4
              });
            case 1:
              res = _context5.v;
              this.storeType = true;
              this.formStoreSelect = res;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleStoreListSelect() {
        return _handleStoreListSelect.apply(this, arguments);
      }
      return handleStoreListSelect;
    }(),
    // 删除店铺
    offlineStoreDelete: function () {
      var _offlineStoreDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
        var _this7 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.$confirm('确认要删除当前店铺吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _context6.n = 1;
                      return offSetApi.offlineStoreDelete({
                        id: id
                      });
                    case 1:
                      _this7.$message({
                        type: 'success',
                        message: '删除成功!'
                      });
                      _this7.handleApiOffsetList(_this7.listPram);
                    case 2:
                      return _context6.a(2);
                  }
                }, _callee6);
              }))).catch(function () {
                _this7.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function offlineStoreDelete(_x3) {
        return _offlineStoreDelete.apply(this, arguments);
      }
      return offlineStoreDelete;
    }(),
    beforeUpload: function () {
      var _beforeUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(file) {
        var formData, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _context8.n = 1;
              return offSetApi.fflineEmpGetreSetImport(formData);
            case 1:
              res = _context8.v;
              if (res != '导入成功') {
                this.dowCoExcleText = res;
                this.$message.error('导入失败！');
              } else {
                this.$message.success('导入成功！');
              }
              this.handerSearch();
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function beforeUpload(_x4) {
        return _beforeUpload.apply(this, arguments);
      }
      return beforeUpload;
    }(),
    // 查看员工
    openNavgetToUsers: function openNavgetToUsers(row) {
      this.$router.push({
        path: '/offStore/users',
        query: {
          id: row.id,
          offlineSupplierId: row.offlineSupplierId
        }
      });
    },
    handleOpenDolaPopup: function handleOpenDolaPopup() {
      this.dowCoExcleText = '';
      this.dialogAddVisible = true;
    },
    // 下载模板
    addDowExcel: function () {
      var _addDowExcel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res, _t;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return (0, _componentsApi.excelTemplateApi)('OfflineStore.xlsx');
            case 1:
              res = _context9.v;
              window.open(res.fileName);
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t = _context9.v;
            case 3:
              return _context9.a(2);
          }
        }, _callee9, null, [[0, 2]]);
      }));
      function addDowExcel() {
        return _addDowExcel.apply(this, arguments);
      }
      return addDowExcel;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleApiOffsetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleApiOffsetList(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    // 导出
    exportList: function exportList() {
      dangaoActApi.exportOrderList(this.listPram).then(function (res) {
        window.open(res.fileName);
      });
    }
  }
};